import * as React from "react";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
// import Typography from '@material-ui/core/Typography';
import Button from "@material-ui/core/Button";

import MenuIcon from "@material-ui/icons/Menu";

import { Auth } from "aws-amplify";
import Logo from "../logo";

interface AppHeaderProps {
  onToggleMenu: () => void;
}

const handleLogout = () => {
  Auth.signOut();
  window.location.reload();
};

export const AppHeader: React.FC<AppHeaderProps> = (props) => {
  return (
    <AppBar position="static" color="default">
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={props.onToggleMenu}
        >
          <MenuIcon />
        </IconButton>
        <Logo color="red" style={{ flexGrow: 1 }} />
        <Button color="inherit" onClick={handleLogout}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};
